import flatpickr from "flatpickr";
let pickers = document.querySelectorAll('.datepicker');
let rangedpickers = document.querySelectorAll('.datepicker-ranged');

let timepickers = document.querySelectorAll('.datetimepicker');
let timerangedpickers = document.querySelectorAll('.datetimepicker-ranged');

let monthpickers = document.querySelectorAll('.monthpicker');

[].forEach.call(monthpickers, el => {

  flatpickr(el, {
    altInput: true,
    altFormat: "F",
    dateFormat: "Y-m-d",
  });
});

[].forEach.call(pickers, el => {
  flatpickr(el, {
    altInput: true,
    altFormat: "F j, Y",
    dateFormat: "Y-m-d",

    onChange: () => {
      buildDependants();
    }
  });
});

function buildDependants() {
  [].forEach.call(rangedpickers, el => {
    let dependantName = el.getAttribute('data-dependant');
    let dependant = document.querySelector('input[name="' + dependantName + '"]');
    if (!dependant) {
      return;
    }

    flatpickr(el, {
      minDate: dependant.value,
      altInput: true,
      altFormat: "F j, Y",
      dateFormat: "Y-m-d"
    });
  });
}

buildDependants();

[].forEach.call(timepickers, el => {

  flatpickr(el, {
    altInput: true,
    altFormat: "F j, Y h:i K",
    enableTime: true,
    dateFormat: "Y-m-d H:i:00",

    onChange: () => {
      buildTimeDependants();
    }
  });
});

function buildTimeDependants() {
  [].forEach.call(timerangedpickers, el => {
    let dependantName = el.getAttribute('data-dependant');
    let dependant = document.querySelector('input[name="' + dependantName + '"]');
    if (!dependant) {
      return;
    }

    flatpickr(el, {
      minDate: dependant.value,
      altInput: true,
      altFormat: "F j, Y h:i K",
      enableTime: true,
      dateFormat: "Y-m-d H:i:00",
    });
  });
}

buildTimeDependants();



// WEBPACK FOOTER //
// ./resources/assets/website/scripts/date-picker.js